"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SitewidePromoBarPlaceholder", {
  enumerable: true,
  get: function get() {
    return _SitewidePromoBarPlaceholder.SitewidePromoBarPlaceholder;
  }
});
var _SitewidePromoBarPlaceholder = require("./SitewidePromoBarPlaceholder");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfU2l0ZXdpZGVQcm9tb0JhclBsYWNlaG9sZGVyIiwicmVxdWlyZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NpdGV3aWRlUHJvbW9CYXJQbGFjZWhvbGRlci9pbmRleC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgU2l0ZXdpZGVQcm9tb0JhclBsYWNlaG9sZGVyIH0gZnJvbSBcIi4vU2l0ZXdpZGVQcm9tb0JhclBsYWNlaG9sZGVyXCJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxJQUFBQSw0QkFBQSxHQUFBQyxPQUFBIn0=